import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { BsFillReplyAllFill, BsDash } from "react-icons/bs";
import { FiChevronUp } from "react-icons/fi";
import { tipu, ieltsBg } from "../../assets";
import TopBanner from "../../components/designTab/TopBanner";
import CoursesIntro from "../../components/pageProps/CoursesIntro";
import Bonus from "../../components/pageProps/Bonus";

const Ielts = () => {
  const [showModuleOne, setShowModuleOne] = useState(true);
  const [showModuleTwo, setShowModuleTwo] = useState(false);
  const [showTestPattern, setShowTestPattern] = useState(false);

  // ================ Course Module start here ==================
  const [showListeningModule, setShowListeningModule] = useState(false);

  // ================ Course Module end here ====================
  return (
    <div className="w-full h-auto">
      <Helmet>
        <title>IELTS - EduCare English Learning Academy</title>
      </Helmet>
      <TopBanner titleText="IELTS" />
      <div className="max-w-screen-xl mx-auto pb-4 pt-2 px-4 flex flex-col lgl:flex-row items-start xl:gap-10 justify-between">
        <div className="w-full flex flex-col gap-4 md:gap-10">
          <CoursesIntro
            intro="Introduction"
            des="IELTS score is internationally recognized as an English Language
              proficiency requirement for higher education, in almost all
              countries including the USA, the United Kingdom, Australia,
              Canada, and New Zealand. The highest possible band score is 9.0;
              most universities accept a score of 6.0 for undergraduate
              admission and 6.0-7.0 for graduate admission."
            instructorName="Masud Parvej Tipu"
            instructorTitle="Head Of Faculty, English"
            instructorImg={tipu}
            classTitle="Regular Class"
            classNo="24"
            langClubTitle="LANGUAGE CLUB"
            langClubNo="12"
            debate="Mock Tests"
            supportTitle="counselling"
            bg={ieltsBg}
          />
          {/* =====================================================
                        Course overview start here
           ===================================================== */}

          <div>
            <h3 className="font-titleFont text-xl md:text-2xl font-semibold mb-1 md:mb-4">
              Why IELTS course is for you?
            </h3>
            <div className="w-full border hover:shadow-lg transition-hover duration-300 border-primeColor rounded-md border-opacity-30 p-4 flex justify-start items-center gap-4">
              <div>
                <p className="text-[16px] font-bodyFont tracking-wide text-gray-600">
                  IELTS exam score is accepted in more than 11,000 institutions
                  in the world, including 3,400 institutions in the United
                  States. This test thoroughly tests the candidate's ability to
                  speak, read, listen and write English. Being a foreign
                  language, many are afraid of English grammar. But happily, the
                  IELTS test is not based on grammar. It is basically a
                  language-based auditing method. You need four English language
                  skills to achieve the desired score: reading, writing,
                  listening, and speaking. The more proficient one is in these
                  four areas, the better one will score on the IELTS test.
                </p>
                <ul className="flex flex-col mt-2 gap-1 font-bodyFont text-gray-700">
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Those who want To go abroad for higher education or a job.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    For those who fear the IELTS test or don't know where to
                    start with IELTS preparation.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Those who wish to apply for permanent residence abroad after
                    completing higher education or while living in the country.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Those who have taken the exam before but want to increase
                    their IELTS Band Score.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Those who want to improve their reading, writing, listening,
                    and speaking skills in work or business, or personal
                    interest.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    For those who fear the IELTS test, or who don't know where
                    to start with IELTS preparation.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* =====================================================
                        Course overview end here
           ===================================================== */}
          {/* =====================================================
                        Course MODULE start here
           ===================================================== */}

          <h3 className="font-titleFont text-xl md:text-2xl font-semibold -mb-4">
            Course Materials
          </h3>
          <div className="w-full border hover:shadow-lg transition-hover duration-200 border-primeColor rounded-md border-opacity-30 p-4">
            {/* =================== Academic Module Start here ============== */}
            <div>
              <h3
                onClick={() => setShowModuleOne(!showModuleOne)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Academic Module :
                {showModuleOne ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showModuleOne && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        The IELTS Academic module test assesses whether you have
                        adequate English Language proficiency to take a degree
                        course or professional training. Students seeking entry
                        to a university or an institution of higher education
                        need to take Academic Module.
                      </li>
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        4 of our In-house books on the Sections-Reading,
                        Listening, Writing, and Speaking.
                      </li>
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        2 supplementary books endorsed by National Geographic's
                        Cengage Learning Initiative, with key for online
                        practice.
                      </li>
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        2 Listening CDs, 1 Speaking DVD, and everyday lecture
                        sheets.
                      </li>
                    </ul>
                  </div>
                  <div className="w-full flex flex-col mt-2">
                    <h3 className="text-lg text-primeColor font-semibold underline underline-offset-4">
                      Regular
                    </h3>
                    <p className="text-base font-semibold tracking-wide">
                      1.5 month; 4 days/week; 15 Classes + 10 Mock Tests.
                    </p>
                  </div>
                  <div className="w-full flex flex-col mt-2">
                    <h3 className="text-lg text-primeColor font-semibold underline underline-offset-4">
                      Executive
                    </h3>
                    <p className="text-base font-semibold tracking-wide">
                      3.5 months; Friday-Saturday; 30 classes + 20 Mock Tests.
                    </p>
                  </div>
                  <div className="w-full flex flex-col mt-2">
                    <h3 className="text-lg text-primeColor font-semibold underline underline-offset-4">
                      Crash
                    </h3>
                    <p className="text-base font-semibold tracking-wide">
                      1.5 month; 4 days/week; 15 Classes + 10 Mock Tests.
                    </p>
                  </div>
                  <div className="w-full flex flex-col mt-2">
                    <h3 className="text-lg text-primeColor font-semibold underline underline-offset-4">
                      IELTS GT
                    </h3>
                    <p className="text-base font-semibold tracking-wide">
                      3 months; 3 days/week; 24 classes + 20 Mock Tests.
                    </p>
                  </div>
                  <div className="w-full flex flex-col mt-2">
                    <h3 className="text-lg text-primeColor font-semibold underline underline-offset-4">
                      Basic Package
                    </h3>
                    <p className="text-base font-semibold tracking-wide">
                      6-7 months (combination of 3 courses: Spoken English +
                      Grammar-Writing + Regular IELTS).
                    </p>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* =================== Academic Module end here ============== */}

            {/* =================== General Training Module Start here ============== */}
            <div>
              <h3
                onClick={() => setShowModuleTwo(!showModuleTwo)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                General Training Module :
                {showModuleTwo ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showModuleTwo && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        The General Training module is designed for students
                        seeking entry to a secondary school or to short
                        course/vocational training courses or for individuals
                        seeking immigration.
                      </li>
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        4 of our In-house books on the Sections-Reading,
                        Listening, Writing, and Speaking.
                      </li>
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        2 supplementary books endorsed by National Geographic’s
                        Cengage Learning Initiative, with key for online
                        practice.
                      </li>
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        2 Listening CDs, 1 Speaking DVD, and everyday lecture
                        sheets.
                      </li>
                    </ul>
                  </div>
                  <div className="w-full flex flex-col mt-2">
                    <h3 className="text-lg text-primeColor font-semibold underline underline-offset-4">
                      Regular
                    </h3>
                    <p className="text-base font-semibold tracking-wide">
                      3.5 months; 3 days/week; 30 classes + 20 Mock Tests.
                    </p>
                  </div>
                  <div className="w-full flex flex-col mt-2">
                    <h3 className="text-lg text-primeColor font-semibold underline underline-offset-4">
                      Executive
                    </h3>
                    <p className="text-base font-semibold tracking-wide">
                      3.5 months; Friday-Saturday; 30 classes + 20 Mock Tests.
                    </p>
                  </div>
                  <div className="w-full flex flex-col mt-2">
                    <h3 className="text-lg text-primeColor font-semibold underline underline-offset-4">
                      Crash
                    </h3>
                    <p className="text-base font-semibold tracking-wide">
                      1.5 month; 4 days/week; 15 Classes + 10 Mock Tests.
                    </p>
                  </div>
                  <div className="w-full flex flex-col mt-2">
                    <h3 className="text-lg text-primeColor font-semibold underline underline-offset-4">
                      IELTS GT
                    </h3>
                    <p className="text-base font-semibold tracking-wide">
                      3 months; 3 days/week; 24 classes + 20 Mock Tests.
                    </p>
                  </div>
                  <div className="w-full flex flex-col mt-2">
                    <h3 className="text-lg text-primeColor font-semibold underline underline-offset-4">
                      Basic Package
                    </h3>
                    <p className="text-base font-semibold tracking-wide">
                      6-7 months (combination of 3 courses: Spoken English +
                      Grammar-Writing + Regular IELTS).
                    </p>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* =================== General Training Module end here ============== */}
            {/* =================== Test pattern Start here ============== */}
            <div>
              <h3
                onClick={() => setShowTestPattern(!showTestPattern)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Test pattern :
                {showTestPattern ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showTestPattern && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Part 1: Listening (4 sections; 30 minutes)
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Part 2: Reading (3 passages; 60 minutes)
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Part 3: Writing (2 tasks; 60 minutes)
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Part 4: Speaking (Interview; 10-15 minutes)
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
              <div>
                <h3
                  onClick={() => setShowListeningModule(!showListeningModule)}
                  className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
                >
                  Course Facilities :
                  {showListeningModule ? (
                    <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                      <FiChevronUp />
                    </span>
                  ) : (
                    <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                      <FiChevronUp />
                    </span>
                  )}
                </h3>
                {showListeningModule && (
                  <>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          "Academic IELTS" and "General IELTS" - both modules
                          can be prepared effectively at home. This course has
                          two separate sections for the two modules.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          You can prepare by hand by solving all types of IELTS
                          questions correctly.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Apart from watching the video, you can revise by
                          looking at the notes in the course.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          After completing the course, you can brush up on your
                          preparation by giving 15 mock tests.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          IELTS test section format, question and answer format,
                          important tips, tricks, and strategies.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Structure and Essay type help to get good scores in
                          IELTS Writing Task 1 and IELTS Writing Task 2.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          How to speak accurately on any topic using
                          Advanced/Power Words in the IELTS Speaking test.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Detailed understanding of each module including rules
                          and regulations.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Strategies to get good scores through proper use of
                          the time allotted during the IELTS test.
                        </li>
                      </ul>
                    </div>
                  </>
                )}
                <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
              </div>
            </div>
            {/* =================== Test pattern end here ============== */}
          </div>
          {/* =====================================================
                        Course MODULE end here
           ===================================================== */}
          {/* =====================================================
                        Course MODULE start here
           ===================================================== */}

          {/* <h3 className="font-titleFont text-xl md:text-2xl font-semibold -mb-4">
            Course Modules
          </h3>
          <div className="w-full border hover:shadow-lg transition-hover duration-200 border-primeColor rounded-md border-opacity-30 p-4"> */}
          {/* =================== Listening Module Start here ============== */}
          {/* <div>
              <h3
                onClick={() => setShowListeningModule(!showListeningModule)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Course Facilities :
                {showListeningModule ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showListeningModule && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        "Academic IELTS" and "General IELTS" - both modules can
                        be prepared effectively at home. This course has two
                        separate sections for the two modules.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        You can prepare by hand by solving all types of IELTS
                        questions correctly.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Apart from watching the video, you can revise by looking
                        at the notes in the course.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        After completing the course, you can brush up on your
                        preparation by giving 15 mock tests.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        IELTS test section format, question and answer format,
                        important tips, tricks, and strategies.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Structure and Essay type help to get good scores in
                        IELTS Writing Task 1 and IELTS Writing Task 2.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        How to speak accurately on any topic using
                        Advanced/Power Words in the IELTS Speaking test.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Detailed understanding of each module including rules
                        and regulations.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Strategies to get good scores through proper use of the
                        time allotted during the IELTS test.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
          </div> */}
          <div>
            <Bonus
              bonus="Language Club."
              awards="Based on your performance, you will be awarded. Also, we will provide you with the certificate after completing the course."
            />
          </div>
          {/* =====================================================
                        Course MODULE end here
           ===================================================== */}
        </div>
      </div>
    </div>
  );
};

export default Ielts;
